module.exports = __webpack_public_path__ + "img/dashboard_profesor.9ae5e266.png";